import i18n from 'i18next';

export function formatDate (dateInput: string | Date): string {
  const date = new Date(dateInput);

  if (Number.isNaN(date.getTime())) {
    return '--';
  }

  const lang = i18n.language;
  const locale = lang !== undefined && lang.trim() !== '' ? lang : 'es-MX';

  return date.toLocaleDateString(locale, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}
